import { makeAutoObservable } from 'mobx'
import { api } from 'store/api'
import { InferenceStore } from 'store/inference/InferenceStore'
import { stat } from 'store/stat'
import { AbuseCode, getAbuseCodeLabel } from 'type/Abuse'
import { sendEvent } from 'util/message'

export class FeedbackStore {
  readonly inference: InferenceStore
  code?: AbuseCode
  private _text_raw = ''

  constructor(inference: InferenceStore) {
    makeAutoObservable(this)
    this.inference = inference
  }

  checked(code: AbuseCode): boolean {
    return this.code === code
  }

  toggle(code: AbuseCode): void {
    this.code = code
  }

  get text(): string {
    return this._text_raw.replaceAll(/\s+/g, ' ').trim()
  }

  get text_raw(): string {
    return this._text_raw
  }

  set text_raw(value: string | undefined) {
    this._text_raw = value || ''
  }

  get canSend(): boolean {
    return !!this.code
  }

  send() {
    const { inference_id, identity_id, item_id, collection_id, image_id, items } = this.inference
    const code = this.code
    if (!image_id || !code) return
    const reason = this.text || getAbuseCodeLabel(code)
    void api.sendInferenceFeedback(image_id, code, reason)
    void stat.feedback(item_id, collection_id, identity_id, inference_id, image_id, code, reason)
    sendEvent('on-feedback', { inference_id, items, reason })
  }
}
